export default "__VITE_ASSET__D5pE_9j3__"